import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Container } from '@/components/ui/layout';
import { cn } from '@/lib/utils';

function TopicSelector() {
    const navigate = useNavigate();
  return (
    <div className="u-topicSelectorA1101">
      <div className="u-selectorContentA1102">
        <h2>Enter Interview Topic</h2>
        <div className="u-topicInputA1103">
          <label>Select Topic:</label>
          <div className="u-selectWrapperA1104">
            <select aria-label="u-Select interview topic">
              <option value="">Select Topic:</option>
            </select>
            <img 
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/5a254f7c2965266cfe0d35eb0dab9b724f9489da21833459b66d152a117daf41?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
              alt="Dropdown arrow"
            />
          </div>
        </div>
        <button className="u-startButtonA1105" onClick={()=>navigate('/questions')}>
          <img 
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c9869c30c0432dc3aa380ec1163ca66000e2ecc490a1cd26241dad8680fb62e9?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
            alt=""
          />
          Get Started
        </button>
      </div>
    </div>
  );
}

export default TopicSelector;
